module.exports = __webpack_public_path__ + "img/tv_taobao.0e14fcba.jpg";